import { cn } from "@/lib/utils";

export function getInitials(name = "") {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return "?";
  }
  const [first, second] = words;
  return `${first[0]}${second ? second[0] : ""}`.toUpperCase();
}

/** The circle with initials shown in a tile when the camera is off. */
export const PeerAvatar = ({ name, className, ...props }) => (
  <div
    className={cn(
      "flex size-16 items-center justify-center rounded-full bg-brand-solid text-lg font-semibold text-white select-none",
      className
    )}
    aria-hidden="true"
    {...props}
  >
    {getInitials(name)}
  </div>
);
